if (!customElements.get("sticky-atc-bar")) {
	customElements.define(
		"sticky-atc-bar",
		class StickyAtcBar extends HTMLElement {
			constructor() {
				super();
				document.body.classList.add("sticky-atc-bar-enabled");

				this.selectors = {
					variantIdSelect: '[name="id"]',
				};
			}

			get quantityInput() {
				return this.querySelector("quantity-input input");
			}
			get quantity() {
				return this.querySelector("quantity-input");
			}
			get sectionId() {
				return this.dataset.originalSection || this.dataset.section;
			}
			get productId() {
				return this.getAttribute("data-product-id");
			}
			get select() {
				return this.querySelector("select");
			}
			get productForm() {
				return this.querySelector('form[is="product-form"]');
			}

			connectedCallback() {
				this.productFormActions = document.querySelector(".main-product-form");
				this.mainProductInfo = document.querySelector("product-info");
				this.container = this.closest(".sticky-atc-bar");

				this.variantData = this.getVariantData();

				this.init();
				this.select.addEventListener("change", () => {
					if (this.isUpdating) return;
					this.isUpdating = true;

					this.updateQuantityInput();

					this.mainVariantSelects = this.mainProductInfo && this.mainProductInfo.querySelector("variant-selects");
					const selectedVariantId = this.querySelector(this.selectors.variantIdSelect).value;
					this.currentVariant = this.variantData.find((variant) => variant.id === Number(selectedVariantId));

					if (this.mainVariantSelects && this.currentVariant) {
						Array.from(
							this.mainVariantSelects.querySelectorAll("select:not(#custom-swatch-colors), fieldset:not(#custom-swatch-colors)"),
							(element, index) => {
								const variantOptionVal = this.currentVariant.options[index];
								switch (element.tagName) {
									case "SELECT":
										element.value = variantOptionVal;
										const options = element.querySelectorAll("option");
										options.forEach((option) => option.removeAttribute("selected"));

										element.value = variantOptionVal;
										const selectedOption = element.querySelector(`option[value="${variantOptionVal}"]`);
										if (selectedOption) {
											selectedOption.setAttribute("selected", "selected");
										}
										break;
									case "FIELDSET":
										Array.from(element.querySelectorAll("input")).forEach((radio) => {
											if (radio.value === variantOptionVal) {
												radio.checked = true;
											}
										});
										break;
								}
							}
						);
						setTimeout(() => {
							this.mainVariantSelects.dispatchEvent(new Event("change", { detail: { formStickty: true } }));
							this.isUpdating = false;
						}, 0);
					} else {
						this.isUpdating = false;
					}

					this.updatePrice();
					this.updateButton(true, "", false);
					if (!this.currentVariant) {
						this.updateButton(true, "", true);
					} else {
						this.updateButton(!this.currentVariant.available);
					}

					// Show/hide unavailable message
					const unavailableMsg = this.querySelector("#variant-unavailable-message");
					if (unavailableMsg) {
						if (this.currentVariant && this.currentVariant.available === false) {
							unavailableMsg.style.display = "";
						} else {
							unavailableMsg.style.display = "none";
						}
					}
				});

				// Add scroll-to-restock-notify-email on create alert button click
				const alertBtn = this.querySelector(".btn-create-alert");
				if (alertBtn) {
					alertBtn.addEventListener("click", () => {
						const emailInput = document.getElementById("restock-notify-email");
						if (emailInput) {
							emailInput.scrollIntoView({ behavior: "smooth", block: "center" });
							emailInput.focus();
						}
					});
				}
			}

			updateQuantityInput() {
				// Always re-fetch variantData from the latest DOM/script
				const jsonScript = this.closest(".sticky-atc-bar")?.querySelector('script[type="application/json"]');
				if (jsonScript) {
					try {
						this.variantData = JSON.parse(jsonScript.textContent);
					} catch (_e) {
						void _e;
						// fallback: do nothing
					}
				}

				const variantIdInput = this.querySelector(this.selectors.variantIdSelect);
				if (!variantIdInput) return; // Defensive: input not found
				const selectedVariantId = variantIdInput.value;

				this.currentVariant = this.variantData && this.variantData.find((variant) => variant.id === Number(selectedVariantId));

				if (!this.currentVariant || !this.currentVariant.id) return;

				fetch(`${this.getAttribute("data-url")}?variant=${this.currentVariant.id}&section_id=${this.sectionId}`)
					.then((response) => response.text())
					.then((responseText) => {
						const parsedHTML = new DOMParser().parseFromString(responseText, "text/html");
						const quantity = document.querySelector(`#QuantitySticky-${this.sectionId}`);
						const newQuantity = parsedHTML.querySelector(`#QuantitySticky-${this.sectionId}`);
						if (quantity && newQuantity) {
							quantity.innerHTML = newQuantity.innerHTML;
						}
					})
					.catch((error) => {
						console.error(error);
					});
			}

			getVariantData() {
				this.variantData = this.variantData || JSON.parse(this.container.querySelector('[type="application/json"]').textContent);
				return this.variantData;
			}

			init() {
				if (!this.productFormActions) {
					this.container.classList.add("sticky-atc-bar--show");
					return;
				}

				const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
				mql.onchange = this.checkDevice.bind(this);
				this.checkDevice();

				const rootMargin = `-80px 0px 0px 0px`;
				this.observer = new IntersectionObserver(
					(entries) => {
						entries.forEach((entry) => {
							const method = entry.intersectionRatio !== 1 ? "add" : "remove";
							this.container.classList[method]("sticky-atc-bar--show");
						});
					},
					{ threshold: 1, rootMargin }
				);
				this.setObserveTarget();
				this.syncWithMainProductForm();

				this.listenClickButton();
			}

			listenClickButton(){
				//listen click on button with ID add-to-cart-btn-sticky and trigger submit on main product form
				const addToCartBtn = this.querySelector("#add-to-cart-btn-sticky");
				if (addToCartBtn) {
					addToCartBtn.addEventListener("click", (e) => {
						e.preventDefault();
						const mainProductForm = document.querySelector(".main-product-form");
						if (mainProductForm) {
							mainProductForm.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
						} else {
							console.warn("Main product form not found.");
						}
					});
				}
			}

			setObserveTarget() {
				this.observer.observe(this.productFormActions);
				this.observeTarget = this.productFormActions;
			}

			checkDevice(_e) {
				document.documentElement.style.setProperty("--sticky-atc-bar-height", this.clientHeight + "px");
			}

			updateButton(disable = true, text, _modifyClass = true) {
				const productForm = this.querySelector("#product-form-sticky-atc-bar");
				// Support for sticky-atc-bar__form as fallback
				const fallbackForm = this.querySelector(".sticky-atc-bar__form");
				const form = productForm || fallbackForm;
				if (!form) return;

				const addButton = form.querySelector('[name="add"]');
				const alertBtn = form.querySelector(".btn-create-alert");
				const unavailableMsg = this.querySelector("#variant-unavailable-message");

				// Show/hide Add to Cart button and create alert
				if (this.currentVariant && !this.currentVariant.available) {
					if (addButton) addButton.style.display = "none";
					if (alertBtn) alertBtn.style.display = "";
					if (unavailableMsg) unavailableMsg.style.display = "";
				} else {
					if (addButton) addButton.style.display = "";
					if (alertBtn) alertBtn.style.display = "none";
					if (unavailableMsg) unavailableMsg.style.display = "none";
				}

				if (!addButton) return;

				const addButtonText = addButton.querySelector("span");
				if (disable) {
					addButton.setAttribute("disabled", "disabled");
					if (text) addButtonText.textContent = text;
				} else {
					addButton.removeAttribute("disabled");
					addButtonText.textContent = FoxTheme.variantStrings.addToCart;
				}
			}

			updatePrice() {
				if (this.currentVariant === undefined) return;

				const classes = {
					onSale: "f-price--on-sale",
					soldOut: "f-price--sold-out",
				};
				const selectors = {
					priceWrapper: ".f-price",
					salePrice: ".f-price-item--sale",
					compareAtPrice: [".f-price-item--regular"],
				};
				const moneyFormat = FoxTheme.settings.moneyFormat;
				const { priceWrapper, salePrice, compareAtPrice } = FoxTheme.utils.queryDomNodes(selectors, this);

				const { compare_at_price, price } = this.currentVariant;

				// On sale.
				if (compare_at_price && compare_at_price > price) {
					priceWrapper.classList.add(classes.onSale);
				} else {
					priceWrapper.classList.remove(classes.onSale);
				}

				// Sold out.
				if (!this.currentVariant.available) {
					priceWrapper.classList.add(classes.soldOut);
				} else {
					priceWrapper.classList.remove(classes.soldOut);
				}

				if (salePrice) {
					salePrice.innerHTML = FoxTheme.Currency.formatMoney(price, moneyFormat);
				}

				if (compareAtPrice && compareAtPrice.length && compare_at_price > price) {
					compareAtPrice.forEach((item) => {
						item.innerHTML = FoxTheme.Currency.formatMoney(compare_at_price, moneyFormat);
						item.style.textDecoration = "line-through";
					});
				} else {
					compareAtPrice.forEach((item) => {
						item.innerHTML = FoxTheme.Currency.formatMoney(price, moneyFormat);
						item.style.textDecoration = "none";
					});
				}
			}

			syncWithMainProductForm() {
				FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, (event) => {
					const isMainProduct = event.data.sectionId === this.mainProductInfo.dataset.section;
					if (!isMainProduct) return;
					const variant = event.data.variant;
					const variantInput = this.querySelector('[name="id"]');

					this.currentVariant = variant;
					variantInput.value = variant.id;
					this.updatePrice();
					this.updateButton(true, "", false);
					if (!variant) {
						this.updateButton(true, "", true);
					} else {
						this.updateButton(!variant.available, FoxTheme.variantStrings.soldOut);
					}

					this.updateQuantityInput();
				});
			}
		}
	);
}
